"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnapButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const content_1 = require("../content");
const datatypes_1 = require("../datatypes");
const web_core_ui_1 = require("@snapchat/web-core-ui");
const SnapButton_module_css_1 = __importDefault(require("./SnapButton.module.css"));
/**
 * Snapchat Logo button
 */
function SnapButton({ homeLink, label, width = 24, height = 24, onClick, }) {
    return ((0, jsx_runtime_1.jsx)("a", { onClick: (event) => onClick?.(event, datatypes_1.DesktopNavItemType.SNAPCHAT_OVERVIEW), href: homeLink, "aria-label": label, className: SnapButton_module_css_1.default.container, title: content_1.HOME_LINK_TITLE, "data-testid": "ConsumerNav_ImageIcon", children: (0, jsx_runtime_1.jsx)(web_core_ui_1.GhostIconFilled, { width: width, height: height }) }));
}
exports.SnapButton = SnapButton;
//# sourceMappingURL=SnapButton.js.map